<!-- Mobile overlay -->
@if (mobileOpen()) {
  <div class="sidebar-overlay" (click)="closeMobile()"></div>
}

<aside class="sidebar" [class.collapsed]="collapsed()" [class.mobile-open]="mobileOpen()">
  @for (group of navGroups(); track group.label) {
    <div class="nav-group">
      @if (!collapsed()) {
        <div class="nav-group-label">{{ group.label }}</div>
      }
      @for (item of group.items; track item.route) {
        <a class="nav-item" [routerLink]="item.route" routerLinkActive="active" [attr.aria-label]="collapsed() ? item.label : null"
           (click)="closeMobile(); flyout.set(null)"
           (mouseenter)="showFlyout($event, item.label)" (mouseleave)="flyout.set(null)"
           (focus)="showFlyout($event, item.label)" (blur)="flyout.set(null)">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <path [attr.d]="getIconPath(item.icon)"/>
            </svg>
          </span>
          @if (!collapsed()) {
            <span class="nav-label">{{ item.label }}</span>
            @if (item.badge) {
              <span class="nav-badge">{{ item.badge }}</span>
            }
          }
          @if (collapsed() && item.badge) {
            <span class="nav-badge-dot"></span>
          }
        </a>
      }
    </div>
  }

  <div class="sidebar-footer">
    @if (!collapsed()) {
      <div class="sidebar-brand">
        <span>SiteWareOS</span>
        <span class="version">v1.0</span>
      </div>
    }
  </div>
</aside>

<!-- Menu closed: the hovered icon's name, sliding out beside it (over the page, not clipped by the menu). -->
@if (collapsed() && flyout(); as f) {
  <div class="nav-flyout" [style.top.px]="f.top" [style.height.px]="f.height" role="tooltip">{{ f.label }}</div>
}
